import htmx from 'htmx.org'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

window.htmx = htmx
window.Sprig ??= { components: [] }

export const initHtmx = () => {
	document.addEventListener('htmx:afterSettle', () => ScrollTrigger.refresh())
}

export const processHtmx = (container) => {
	htmx.process(container)
}
